import { render, staticRenderFns } from "./RepresentativeSummary.vue?vue&type=template&id=3f866dc4&"
import script from "./RepresentativeSummary.vue?vue&type=script&lang=js&"
export * from "./RepresentativeSummary.vue?vue&type=script&lang=js&"
import style0 from "./RepresentativeSummary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports